import React, { SVGProps } from "react";

export default function ActionsIcon({ color, ...props }: SVGProps<any>) {
  return (
    <svg viewBox="0 0 24 27" width={24} height={27} {...props}>
      <g fill="none" fillRule="evenodd" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.796}>
        <path d="M2.404 22.487h19.333c.404-.007.773-.212.968-.539a.974.974 0 00-.021-1.043L20.6 17.653V9.42c0-4.672-3.79-8.47-8.53-8.47-4.742 0-8.531 3.798-8.531 8.47v8.234l-2.07 3.252a.974.974 0 00-.025 1.038c.193.326.557.533.959.544z" />
        <path d="M15.595 22.487c.049.195.073.396.072.597 0 1.647-1.607 2.993-3.59 2.993-1.983 0-3.59-1.346-3.59-2.993a2.416 2.416 0 01.072-.597" />
      </g>
    </svg>
  );
}
